import { handleActions } from "redux-actions";
import { COMPANIES } from "constants/action-types";
import { initialFetchState, IFetchStoreState, progressActions } from "reducers/base-reducers";
import type { ICompany } from "components/contacts/contacts-types";

export type ICompaniesState = IFetchStoreState<ICompany[]>;

export const companies = handleActions<ICompaniesState>(
    {
        ...progressActions(COMPANIES.FETCH, "isFetching"),
    } as any,
    { ...initialFetchState }
);
